module.exports = __webpack_public_path__ + "img/6_21.3dbcd7a9.png";